// extracted by mini-css-extract-plugin
export default {"modalContent":"Modals_modalContent__J6Q5X","readOnlyBlock":"Modals_readOnlyBlock__OzCpA","aiText":"Modals_aiText__NMzWG","inputBlock":"Modals_inputBlock__CZdc0"};